module.exports = __webpack_public_path__ + "img/AT0000002569604.d569db1f.png";